/* LAVAZAPAS — carrito sin recargar la pagina */
(function () {
  if (window.__cicloCart) return;
  window.__cicloCart = true;

  function root() { return document.querySelector('.cc-cart'); }

  function bump(el) {
    if (!el) return;
    el.classList.remove('cc-bump');
    el.getBoundingClientRect();
    el.classList.add('cc-bump');
  }

  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function change(line, qty) {
    var el = root();
    if (!el) return;
    var sid = el.getAttribute('data-section');
    el.classList.add('cc-cart-busy');

    fetch(base() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sid, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && data.sections[sid];
        if (!html) { window.location.reload(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cc-cart');
        if (!fresh) { window.location.reload(); return; }
        el.innerHTML = fresh.innerHTML;
        el.classList.remove('cc-cart-busy');
        bump(el.querySelector('.cc-sum-total-v'));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = root();
    if (!el || !el.contains(e.target)) return;

    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      change(parseInt(rm.getAttribute('data-remove'), 10), 0);
      return;
    }
    var step = e.target.closest('[data-step]');
    if (step) {
      e.preventDefault();
      var line = parseInt(step.getAttribute('data-line'), 10);
      var input = el.querySelector('[data-qty="' + line + '"]');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-step'), 10);
      if (isNaN(next) || next < 0) next = 0;
      input.value = next;
      change(line, next);
    }
  });

  document.addEventListener('change', function (e) {
    var el = root();
    if (!el || !e.target || !e.target.closest || !el.contains(e.target)) return;
    var input = e.target.closest('[data-qty]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(parseInt(input.getAttribute('data-qty'), 10), q);
  });
})();
